import { render, staticRenderFns } from "./SignUpProfessional.vue?vue&type=template&id=33856f5d&scoped=true"
import script from "./SignUpProfessional.vue?vue&type=script&lang=js"
export * from "./SignUpProfessional.vue?vue&type=script&lang=js"
import style0 from "./SignUpProfessional.vue?vue&type=style&index=0&id=33856f5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33856f5d",
  null
  
)

export default component.exports